import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import {
  isErudaDefaultOpen,
  isErudaEnabled,
  setErudaDefaultOpen,
  setErudaEnabled,
} from 'utils/initEruda';
import { Button } from '../ui/button';

const Eruda: React.FC = () => {
  const [show, setShow] = useState(false);
  const [enabled, setEnabled] = useState<boolean>(() => isErudaEnabled());
  const [defaultOpen, setDefaultOpen] = useState<boolean>(() =>
    isErudaDefaultOpen()
  );

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Use `code` (physical key) instead of `key` because Alt+Z on some
      // layouts (e.g. macOS) produces a different character like `Ω`.
      if (event.ctrlKey && event.altKey && event.code === 'KeyZ') {
        event.preventDefault();
        event.stopPropagation();
        setShow((prev) => !prev);
      }
    };

    // Use capture so the shortcut fires even when another handler would
    // otherwise consume the event.
    window.addEventListener('keydown', handleKeyDown, true);

    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  const handleToggleEnabled = () => {
    const next = !enabled;
    setEnabled(next);
    setErudaEnabled(next);
  };

  const handleToggleDefaultOpen = () => {
    const next = !defaultOpen;
    setDefaultOpen(next);
    setErudaDefaultOpen(next);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>Eruda</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>In-page browser console for debugging.</p>
        <p>
          Toggling these checkboxes updates the <code>localStorage</code> keys{' '}
          <code>eruda</code> and <code>eruda_default_open</code>.
        </p>
        <div className="form-block">
          <StylishNewCheckbox
            checked={enabled}
            onClick={handleToggleEnabled}
            label="Enable?"
          />
          <StylishNewCheckbox
            checked={defaultOpen}
            onClick={handleToggleDefaultOpen}
            label="Open panel by default?"
          />
        </div>

        <Button
          variant="link"
          onClick={() =>
            window.open('https://github.com/liriliri/eruda', '_blank')
          }
          className="tw:px-0"
        >
          Documentation
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default Eruda;
